<div class="container">
    <div class="row">
      <!-- Right Side: List -->
      <!-- <div class="col-md-4">
        <ul class="list-group">
          <li class="list-group-item" *ngFor="let item of data" (click)="selectedItem = item">
            {{ item.name }}
          </li>
        </ul>
      </div> -->

      <div class="col-md-4">
        <div class="p-inputgroup">
            <input type="text" pInputText placeholder="Search" [(ngModel)]="searchText" (input)="filterData($event)" />
            <button pButton type="button" icon="pi pi-search" (click)="filterData($event)"></button>
          </div>
          
          <p-table [value]="data" [paginator]="true" [rows]="10" [totalRecords]="data.length">
            <ng-template pTemplate="header">
              <tr>
                <th colspan="2">{{"Data Items" | translator}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-dataItem let-rowIndex="rowIndex">
              <tr (click)="selectedItem = dataItem; currentIndex=rowIndex" [ngClass]="selectedItem == dataItem ? 'sbc-btn-color' : '' ">
                <td>{{ rowIndex + 1 }}</td>
                <td>{{ dataItem.name }} <p-chip *ngIf="isEdited[rowIndex]" class="inline-chip small-chip"> <i class="pi pi-pencil edit-icon"></i> </p-chip></td>
              </tr>
            </ng-template>
          </p-table>
      </div>
      
  
      <!-- Left Side: Item Details -->
      <div class="col-md-8">
        <div *ngIf="selectedItem">

          <input type="text" (change)="updateData()" (onTextChange)="updateData()" class="p-inputtext-lg" style="width:100%" pInputText [(ngModel)]="selectedItem.name" />

          <div class="card border-none w-100">
            <div class="card-body">
                
                <p-accordion class="w-full" [multiple]="true" [activeIndex]="0">
                    <p-accordionTab class="my-3" *ngFor="let field of selectedItem?.fields; let i = index"
                        iconPos="end" [selected]="i==0 || i==1">
                        <ng-template pTemplate="header">
                            <div (click)="$event.stopPropagation()" class="d-flex align-items-center">
                                <i [ngClass]="field.label?.icon + ' font-1_2rem'" class="m-2"></i>
                                <span class="vertical-align-middle font-1_1rem">{{field.label?.name}}</span>
                                
                            </div>
                        </ng-template>
                        <ng-template pTemplate="content">
                            <div class="d-flex justify-content-between">
                                <div class="w-100">
                                    <!-- Rich text -->
                                    <div>
                                        <p-editor [(ngModel)]="field.data" (change)="updateData()" (onTextChange)="updateData()"
                                            [style]="{'height':'320px'}"></p-editor>
                                    </div>
                                </div>
                            </div>

                        </ng-template>
                    </p-accordionTab>
                </p-accordion>

            </div>
        </div>
        </div>
        <div *ngIf="!selectedItem">
          <p>{{"Select an item from the list to view details." | translator}}</p>
        </div>
      </div>
    </div>
  </div>
